import { matchPath } from 'react-router-dom';
import { routeTitleMap } from '../constants';

export const getMobileHeaderByRoute = (pathname: string): string => {
  const matchedRoute = Object.keys(routeTitleMap).find((route) => matchPath({ path: route, end: true }, pathname));
  return matchedRoute ? routeTitleMap[matchedRoute] : '';
};
